// test1110
(1110 && 0);
